// @ helpers
const { formatText } = require('core/i18n').i18n;

// @ commons
const { every, findIndex, get } = require('lodash');

// @ constants
const documentsTypes = require('constants/mortgageRequestDocumentsTypes');
const { MORTGAGE_TYPE_TEXT } = require('constants/mortgageRequestMortgageDataTypes');
const {
    EMPLOYMENT_SITUATION,
    ESTATES_TYPE,
    DOCUMENTS_STATUS
} = require('constants/mortgageRequestHolderData');

const documentsRequest = [
    documentsTypes.NS,
    documentsTypes.NS_CLI,
    documentsTypes.TAS,
    documentsTypes.TAS_CLI
];
const personalDocuments = [
    documentsTypes.VL,
    documentsTypes.NOM,
    documentsTypes.NOM_VL,
    documentsTypes.IRPF100,
    documentsTypes.IRPF100_CLI,
    documentsTypes.IRPF130,
    documentsTypes.RECIB_HIPO,
    documentsTypes.RECIB_PREST
];
const sectionsLinks = {
    holderWork: '/myprofile/mortgage/holder-work/',
    holderEconomic: '/myprofile/mortgage/holder-economic/',
    simpleNote: '/myprofile/mortgage/simple-note-result/',
    propertyValue: '/myprofile/mortgage/property-value-defined/'
};
const urlByDocumentType = {
    VL: sectionsLinks.holderWork,
    NOM: sectionsLinks.holderWork,
    NOM_VL: sectionsLinks.holderWork,
    IRPF100: sectionsLinks.holderEconomic,
    IRPF100_CLI: sectionsLinks.holderEconomic,
    IRPF130: sectionsLinks.holderEconomic,
    NS: sectionsLinks.simpleNote,
    NS_CLI: sectionsLinks.simpleNote,
    TAS: sectionsLinks.propertyValue,
    TAS_CLI: sectionsLinks.propertyValue,
    RECIB_HIPO: sectionsLinks.holderEconomic,
    RECIB_PREST: sectionsLinks.holderEconomic
};
const excludeDocumentTypes = [
    documentsTypes.NS_FACT,
    documentsTypes.TAS_DICT,
    documentsTypes.TAS_FACT,
    documentsTypes.FIPER,
    documentsTypes.OV,
    documentsTypes.DRAFT_CONT,
    documentsTypes.INSURANCE_PRE_POLICY,
    documentsTypes.PRE_APROB,
    documentsTypes.FIPRE,
    documentsTypes.INF_GASTOS_HIPO,
    documentsTypes.FIAE,
    documentsTypes.INF_CUOTAS_HIPO,
    documentsTypes.FEIN,
    documentsTypes.ADVERTENCIA_HIPO,
    documentsTypes.MORTGAGE_WRITING_LETTER,
    documentsTypes.MANIFESTACION_FIRMADA_HIPO,
    documentsTypes.NUEVA_LEY_DOC_1,
    documentsTypes.NUEVA_LEY_DOC_2
];
const excludeIRPF100 = [
    EMPLOYMENT_SITUATION.AUTONOMO,
    EMPLOYMENT_SITUATION.FUNCIONARIO_MUFACE,
    EMPLOYMENT_SITUATION.FUNCIONARIO_SEG_SOCIAL,
    EMPLOYMENT_SITUATION.TRABAJADOR_CUENTA_AJENA
];
const excludeIRPF300 = [
    EMPLOYMENT_SITUATION.AUTONOMO
];
const holdersCategory = [
    [
        documentsTypes.NOM_VL,
        documentsTypes.VL,
        documentsTypes.NOM
    ],
    [
        documentsTypes.IRPF100,
        documentsTypes.IRPF100_CLI
    ],
    [
        documentsTypes.IRPF130
    ]
];
const livingPlaceCategory = [
    [
        documentsTypes.NS,
        documentsTypes.NS_CLI
    ],
    [
        documentsTypes.NS_FACT
    ],
    [
        documentsTypes.TAS,
        documentsTypes.TAS_CLI
    ],
    [
        documentsTypes.TAS_DICT
    ],
    [
        documentsTypes.TAS_FACT
    ]
];
const leanCategory = [
    [
        documentsTypes.PRE_APROB
    ],
    [
        documentsTypes.FIPRE
    ],
    [
        documentsTypes.INF_GASTOS_HIPO
    ],
    [
        documentsTypes.FIAE
    ],
    [
        documentsTypes.INF_CUOTAS_HIPO
    ],
    [
        documentsTypes.FEIN
    ],
    [
        documentsTypes.ADVERTENCIA_HIPO
    ],
    [
        documentsTypes.MORTGAGE_WRITING_LETTER
    ],
    [
        documentsTypes.INSURANCE_PRE_POLICY
    ],
    [
        documentsTypes.MANIFESTACION_FIRMADA_HIPO
    ],
    [
        documentsTypes.NUEVA_LEY_DOC_1
    ],
    [
        documentsTypes.NUEVA_LEY_DOC_2
    ]
];
const getDocumentLabel = (documentType, documentSubType, mortgageDataState) => {
    switch (documentType) {
        case documentsTypes.VL:
        case documentsTypes.NOM:
        case documentsTypes.NOM_VL:
            return formatText('mortgageRequestDocumentationCenter-documentTypeVidaLaboralNomina');

        case documentsTypes.IRPF100:
        case documentsTypes.IRPF100_CLI:
            return formatText('mortgageRequestDocumentationCenter-documentTypeIrpf');

        case documentsTypes.IRPF130:
            return formatText('mortgageRequestDocumentationCenter-documentTypeModelo130');

        case documentsTypes.NS:
        case documentsTypes.NS_CLI:
            if (documentSubType === ESTATES_TYPE.VIVIENDA) {
                return formatText('mortgageRequestDocumentationCenter-documentTypeNsVivienda');
            } else if (documentSubType === ESTATES_TYPE.GARAJE) {
                return formatText('mortgageRequestDocumentationCenter-documentTypeNsGarage');
            } else if (documentSubType === ESTATES_TYPE.TRASTERO) {
                return formatText('mortgageRequestDocumentationCenter-documentTypeNsTrastero');
            } else {
                return formatText('mortgageRequestDocumentationCenter-documentTypeNs');
            }

        case documentsTypes.NS_FACT:
            return formatText('mortgageRequestDocumentationCenter-documentTypeFacturaNotaSimple');

        case documentsTypes.TAS:
        case documentsTypes.TAS_CLI:
            return formatText('mortgageRequestDocumentationCenter-documentTypeTasacionInmueble');

        case documentsTypes.TAS_DICT:
            return formatText('mortgageRequestDocumentationCenter-documentTypeInformeTasacion');

        case documentsTypes.TAS_FACT:
            return formatText('mortgageRequestDocumentationCenter-documentTypeFacturaTasacion');

        case documentsTypes.FIPER:
            return formatText('mortgageRequestDocumentationCenter-documentTypeInfoPersonalizada');

        case documentsTypes.FIPRE:
            return formatText('mortgageRequestDocumentationCenter-mortgageRequestDocumentationCenter_quoteFilesPreContractualInfo');

        case documentsTypes.OV:
            return formatText('mortgageRequestDocumentationCenter-documentTypeOfertaVinculante');

        case documentsTypes.DRAFT_CONT:
            return formatText('mortgageRequestDocumentationCenter-documentTypeBorradorEscritura');

        case documentsTypes.RECIB_HIPO:
            return formatText('mortgageRequestDocumentationCenter-documentTypeRecibHipo');

        case documentsTypes.RECIB_PREST:
            return formatText('mortgageRequestDocumentationCenter-documentTypeRecibPrest');

        case documentsTypes.INSURANCE_PRE_POLICY:
            return formatText('mortgageRequestDocumentationCenter-mortgageRequestDocumentationCenter_documentTypeInsurancePrePolicy');

        case documentsTypes.PRE_APROB:
            const mortgageType = MORTGAGE_TYPE_TEXT[mortgageDataState.getIn(['data', 'tipoProducto'])];
            return formatText('mortgageRequestDocumentationCenter-mortgageRequestDocumentationCenter_mortgageDocumentType', [mortgageType]);

        case documentsTypes.FEIN:
            return formatText('mortgageRequestDocumentationCenter-mortgageRequestDocumentationCenter_mortgageFeinDocument');

        case documentsTypes.FIAE:
            return formatText('mortgageRequestDocumentationCenter-mortgageRequestDocumentationCenter_mortgageFiaeDocument');

        case documentsTypes.INF_GASTOS_HIPO:
            return formatText('mortgageRequestDocumentationCenter-mortgageRequestDocumentationCenter_mortgageInfExpensesHipoDocument');

        case documentsTypes.INF_CUOTAS_HIPO:
            return formatText('mortgageRequestDocumentationCenter-mortgageRequestDocumentationCenter_mortgageEscenarioQuotaDocument');

        case documentsTypes.ADVERTENCIA_HIPO:
            return formatText('mortgageRequestDocumentationCenter-mortgageRequestDocumentationCenter_mortgageMandatoryAdviceDocument');

        case documentsTypes.MANIFESTACION_FIRMADA_HIPO:
            return formatText('mortgageRequestDocumentationCenter-mortgageRequestDocumentationCenter_mortgageSignedManifiestationDocument');

        case documentsTypes.MORTGAGE_WRITING_LETTER:
            return formatText('mortgageRequestDocumentationCenter-mortgageRequestDocumentationCenter_mortgageContractProyectDocument');

        case documentsTypes.NUEVA_LEY_DOC_1:
            return formatText('mortgageRequestDocumentationCenter-mortgageRequestDocumentationCenter_newMortgageLawDocument1');

        case documentsTypes.NUEVA_LEY_DOC_2:
            return formatText('mortgageRequestDocumentationCenter-mortgageRequestDocumentationCenter_newMortgageLawDocument2');

        default:
            return '';
    }
}
const getStatus = fileList => {
    if (fileList.length && every(fileList, { 'estado': DOCUMENTS_STATUS.VERIFICADO })) {
        return DOCUMENTS_STATUS.VERIFICADO;
    } else if (findIndex(fileList, item => get(item, 'estado', DOCUMENTS_STATUS.NONE) === DOCUMENTS_STATUS.NO_VALIDO) !== -1) {
        return DOCUMENTS_STATUS.NO_VALIDO;
    } else if (findIndex(fileList, item => {
        const itemStatus = get(item, 'estado', DOCUMENTS_STATUS.NONE);
        return itemStatus === DOCUMENTS_STATUS.NONE || itemStatus === DOCUMENTS_STATUS.PEND_APORTAR
    }) !== -1) {
        return DOCUMENTS_STATUS.NONE;
    } else if (findIndex(fileList, item => get(item, 'estado', DOCUMENTS_STATUS.NONE) === DOCUMENTS_STATUS.PEND_VAL) !== -1) {
        return DOCUMENTS_STATUS.PEND_VAL;
    } else {
        return DOCUMENTS_STATUS.NONE;
    }
}


const initialValuesLivingPlace = () => {
    return {
        NS_VIVIENDA: {
            documentType: documentsTypes.NS,
            documentTypeLabel: getDocumentLabel(documentsTypes.NS, ESTATES_TYPE.VIVIENDA),
            documentStatus: DOCUMENTS_STATUS.PEND_APORTAR,
            documentEstateId: null,
    
        },
        NS_GARAJE: {
            documentType: documentsTypes.NS,
            documentTypeLabel: getDocumentLabel(documentsTypes.NS, ESTATES_TYPE.GARAJE),
            documentStatus: DOCUMENTS_STATUS.PEND_APORTAR,
            documentEstateId: null,
    
        },
        NS_TRASTERO: {
            documentType: documentsTypes.NS,
            documentTypeLabel: getDocumentLabel(documentsTypes.NS, ESTATES_TYPE.TRASTERO),
            documentStatus: DOCUMENTS_STATUS.PEND_APORTAR,
            documentEstateId: null,
    
    
        },
        NS_FACT: {
            documentType: documentsTypes.NS_FACT,
            documentTypeLabel: getDocumentLabel(documentsTypes.NS_FACT),
            documentStatus: DOCUMENTS_STATUS.PEND_APORTAR,
            documentEstateId: null,
        },
        TAS: {
            documentType: documentsTypes.TAS,
            documentTypeLabel: getDocumentLabel(documentsTypes.TAS),
            documentStatus: DOCUMENTS_STATUS.PEND_APORTAR,
            documentEstateId: null,
    
        },
        TAS_DICT: {
            documentType: documentsTypes.TAS_DICT,
            documentTypeLabel: getDocumentLabel(documentsTypes.TAS_DICT),
            documentStatus: DOCUMENTS_STATUS.PEND_APORTAR,
            documentEstateId: null,
    
        },
        TAS_FACT: {
            documentType: documentsTypes.TAS_FACT,
            documentTypeLabel: getDocumentLabel(documentsTypes.TAS_FACT),
            documentStatus: DOCUMENTS_STATUS.PEND_APORTAR,
            documentEstateId: null,
    
        }
    }
}

module.exports = {
    documentsRequest,
    personalDocuments,
    sectionsLinks,
    urlByDocumentType,
    excludeDocumentTypes,
    excludeIRPF100,
    excludeIRPF300,
    holdersCategory,
    livingPlaceCategory,
    leanCategory,
    getDocumentLabel,
    getStatus,
    initialValuesLivingPlace
}
